// extracted by mini-css-extract-plugin
export var headerXL = "Layout-module--headerXL--2OEQ1";
export var headerL = "Layout-module--headerL--1E3A2";
export var headerM = "Layout-module--headerM--C9U3O";
export var headerS = "Layout-module--headerS--1Q4GR";
export var headerXS = "Layout-module--headerXS--1v6Eb";
export var blogHeaderXL = "Layout-module--blogHeaderXL--3Qvaw";
export var blogHeaderL = "Layout-module--blogHeaderL--2hNR8";
export var blogHeaderM = "Layout-module--blogHeaderM--2gh9w";
export var blogHeaderS = "Layout-module--blogHeaderS--2CFbS";
export var blogHeaderXS = "Layout-module--blogHeaderXS--4Gnp4";
export var headerPreamble = "Layout-module--headerPreamble---hfgT";
export var preHeader = "Layout-module--preHeader--2pZ7f";
export var textNormal = "Layout-module--textNormal--16VZr";
export var textSmall = "Layout-module--textSmall--2QGgb";
export var textSmallAlternate = "Layout-module--textSmallAlternate--26jmc";
export var legend = "Layout-module--legend--EafGa";
export var caption = "Layout-module--caption--3SJmG";
export var gradientBackground = "Layout-module--gradientBackground--m3CSF";
export var ellipsis = "Layout-module--ellipsis--1wcSr";
export var globalContainer = "Layout-module--globalContainer--2wS9i";
export var maxWidth = "Layout-module--maxWidth--1W5uC";
export var clipBottom = "Layout-module--clipBottom--OUWEt";
export var clipTopBottom = "Layout-module--clipTopBottom--rAWja";
export var whiteBackground = "Layout-module--whiteBackground--3KhnR";
export var layout = "Layout-module--layout--2whpI";
export var container = "Layout-module--container--12_Lg";
export var main = "Layout-module--main--3QAXp";
export var withAlertBanner = "Layout-module--withAlertBanner--1UuTv";
export var headerCollapsed = "Layout-module--headerCollapsed--1usDo";
export var ch2 = "Layout-module--ch2--1ZNmW";
export var ch2Container = "Layout-module--ch2-container--K0Gh6";